<div [ngStyle]="{ 'background-color': variantColor }">
  <app-icon-transmission-state
    [variant]="transmissionState?.transmissionStatusTag"
    [color]="'#fff'"
    [size]="10"
  ></app-icon-transmission-state>
  <p>{{ description || "empty" }}</p>
</div>
